import * as React from "react";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from "@mui/material";
import MWExceptionList from "../../component/MWExceptionList";
import { t } from "i18next";

export default function ImportFromChat() {
  const importDataFromChat = () => {};

  const bodyMarkup = (
    <Card>
      <CardHeader
        title={
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Grid item>
              <Typography variant="h6">{t("importdadaPage.fromChat", { ns: ["home"] })!}</Typography>
            </Grid>
            <Grid item>
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="flex-end"
              >
                <Grid item>
                  <Button
                    size="large"
                    onClick={importDataFromChat}
                    variant="outlined"
                    startIcon={<ImportExportIcon />}
                  >
                    {t("common.importdata", { ns: ["home"] })!}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
      />
      <CardContent>
        <MWExceptionList />
      </CardContent>
    </Card>
  );

  return <Box>{bodyMarkup}</Box>;
}
